@let results = resultsCount();

<header class="tw:shrink-0 tw:border-b tw:border-gray-6 tw:px-5 tw:pt-5 tw:pb-[15px]">
  <div class="tw:mx-auto tw:flex tw:w-full tw:max-w-[560px] tw:flex-col tw:gap-2.5">
    <div class="tw:flex tw:items-center tw:justify-between tw:gap-5">
      <h2 class="typography-headline-2 tw:text-white">
        {{ 'common.filters.title' | translate }}
      </h2>

      <button
        class="tw:-mr-2.5 tw:flex tw:size-10 tw:cursor-pointer tw:items-center tw:justify-center tw:text-gray-2 tw:transition-colors tw:hover:text-white"
        [attr.aria-label]="'common.filters.close' | translate"
        data-testid="filters-dialog-close"
        (click)="closeDialog.emit()"
      >
        <fr8bot-ui-icon name="menu-x" [size]="16" />
      </button>
    </div>

    <div class="tw:flex tw:min-h-6 tw:items-center tw:gap-[15px]">
      @if (results !== null) {
        <span class="typography-body-2 tw:text-gray-3">
          {{ results }} {{ 'common.filters.results' | translate }}
        </span>
      }

      @if (filtersCount() > 0) {
        <button class="link" data-testid="list-filters-clear" (click)="clearFilters.emit()">
          <span class="tw:underline">{{
            'common.smartFilter.markup.clearFilters' | translate
          }}</span>
          <fr8bot-ui-icon name="x-1-12" [size]="12" />
        </button>
      }
    </div>
  </div>
</header>

<div
  class="scroll-primary tw:min-h-0 tw:flex-1 tw:overflow-y-auto tw:px-5 tw:pt-5 tw:scroll-end-space-5"
>
  <div class="tw:mx-auto tw:flex tw:w-full tw:max-w-[560px] tw:flex-col tw:gap-[30px]">
    <section class="tw:flex tw:flex-wrap tw:items-center tw:gap-[15px] tw:empty:hidden">
      <ng-content select="[settings]" />
    </section>

    <section class="tw:flex tw:flex-col tw:gap-[15px] tw:empty:hidden">
      <ng-content select="[search]" />
    </section>

    <section class="tw:flex tw:flex-col tw:gap-[15px] tw:empty:hidden">
      <ng-content select="[smart-filters]" />
    </section>

    <section class="tw:flex tw:flex-col tw:gap-5 tw:empty:hidden">
      <ng-content />
    </section>
  </div>
</div>

<footer class="tw:shrink-0 tw:border-t tw:border-gray-6 tw:px-5 tw:pt-[15px] tw:pb-5">
  <div class="tw:mx-auto tw:w-full tw:max-w-[560px]">
    <fr8bot-ui-button
      class="tw:w-full"
      type="primaryCut"
      size="medium"
      data-testid="filters-dialog-show"
      (click)="closeDialog.emit()"
    >
      {{ 'common.filters.showResults' | translate }}
    </fr8bot-ui-button>
  </div>
</footer>
